const LOCATION_RADIUS_OPTIONS = [
   {
      value: '5',
      label: '5 Miles',
      id: '5',
      name: '5 Miles',
   },
   {
      value: '25',
      label: '25 Miles',
      id: '25',
      name: '25 Miles',
   },
   {
      value: '50',
      label: '50 Miles',
      id: '50',
      name: '50 Miles',
   },
];

export default LOCATION_RADIUS_OPTIONS;
